"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./get-client-cards-params.interface"), exports);
tslib_1.__exportStar(require("./get-client-cards-result.interface"), exports);
